import React from 'react';

import { useParams } from 'react-router-dom';
import {
  Typography,
  Link,
  Checkbox,
  styled,
  Box,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import { OnboardingParams } from '../../types';

import { getProductPrivacyPolicy, getProductTermsAndConditions } from '@/utils/productHelpers';

const RadioButtonContainer = styled(Box)({
  display: 'flex',
  borderRadius: 8,
  marginBottom: 12,
  alignItems: 'center',
});

interface TermsAndConditionsAcknowledgementsProps {
  safetyAcknowledgement: boolean;
  safetyAcknowledgementLabel: string;
  policyAndTermsAcknowledgement: boolean;
  onSelect: (arg1: { safetyAcknowledgement: boolean } | { policyAndTermsAcknowledgement: boolean }) => void;
}

export const TermsAndConditionsAcknowledgements: React.FC<TermsAndConditionsAcknowledgementsProps> = ({
  safetyAcknowledgement,
  safetyAcknowledgementLabel,
  policyAndTermsAcknowledgement,
  onSelect,
}) => {
  const { product } = useParams<OnboardingParams>();
  const { t } = useTranslation();

  return (
    <>
      {product !== 'sleepio' && product !== 'spark' && (
        <RadioButtonContainer>
          <Checkbox
            checked={safetyAcknowledgement}
            disableFocusRipple
            style={{ alignSelf: 'flex-start' }}
            onChange={() => {
              onSelect({ safetyAcknowledgement: !safetyAcknowledgement });
            }}
          />
          <Typography>{safetyAcknowledgementLabel}</Typography>
        </RadioButtonContainer>
      )}
      <RadioButtonContainer>
        <Checkbox
          checked={policyAndTermsAcknowledgement}
          disableFocusRipple
          style={{ alignSelf: 'flex-start' }}
          onChange={() => {
            onSelect({ policyAndTermsAcknowledgement: !policyAndTermsAcknowledgement });
          }}
        />
        <Typography>
          {`${t('coverage.i_agree_to_the')} `}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={getProductTermsAndConditions(product)}
          >
            {t('coverage.terms')}
          </Link>
          {`, ${t('coverage.and')} `}
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={getProductPrivacyPolicy(product)}
          >
            {`${t('coverage.privacy_policy')}.`}
          </Link>
        </Typography>
      </RadioButtonContainer>
    </>
  );
};
